import { ContractDto } from '../../../services/dtos/contract.dto';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { useEffect, useRef, useState } from 'react';
import {
    getContratPreferences,
    initContratPreferences,
    updateContratPreferences,
} from '../../../services/contract-gestion-alerte-fuite.service';
import { showAxiosMessageError } from '../../../services/error-message.service';
import ContractGestionAlerteFuiteUi from '../../user-interfaces/contract/gestion-alerte-fuite/contract-gestion-alerte-fuite.ui';
import './contract-gestion-alerte-fuite.scss';
import { ContractGestionAlerteFuiteDto } from '../../../services/dtos/contract-gestion-alerte-fuite.dto';

/**
 * Fetches and displays contract preferencies information.
 *
 * @param {object} props - The props containing the contract object.
 * @param {object} props.contract - The contract object containing contract information.
 *
 * @return {React.Component} - The component displaying the contract preferencies information.
 */
export default function ContractGestionAlerteFuite(props: {
    contract?: ContractDto;
    updateContract: Function;
}): JSX.Element {
    // Snackbar des messages
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [gestionAlerteFuite, setGestionAlerteFuite] = useState<ContractGestionAlerteFuiteDto>();

    const preferenciesFetchError = 'Erreur lors de la récupération des préférences';

    // Récupération des préférences à l'ouverture de la page
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        if (!props?.contract?.rattachementContratPreference) {
            let tmp: any = null;
            initContratPreferences(props.contract?.['@id'])
                .then(data => {
                    props.updateContract({
                        ...props.contract,
                        rattachementContratPreference: `/rattachement_contrat_preferences/${data.id}`,
                    });

                    tmp = data;
                    return data;
                })
                .catch(error => {
                    console.log(error.message);
                    console.error(preferenciesFetchError);
                    showAxiosMessageError(error, showMessage);
                })
                .finally(() => {
                    getContratPreferences(`/rattachement_contrat_preferences/${tmp.id}`)
                        .then(data => {
                            setGestionAlerteFuite({
                                '@id': data['@id'],
                                id: data.id.toString(),
                                alerteFuite: data.alerteFuite,
                                alerteFuiteTypeContact: data.alerteFuiteTypeContact,
                                email: data.mail,
                                tel: data.tel,
                            });
                        })
                        .catch(error => {
                            console.error(preferenciesFetchError);
                            showAxiosMessageError(error, showMessage);
                        })
                        .finally(() => {
                            setLoading(false);
                        });
                });
        } else {
            getContratPreferences(props?.contract?.rattachementContratPreference)
                .then(data => {
                    setGestionAlerteFuite({
                        '@id': data['@id'],
                        id: data.id.toString(),
                        alerteFuite: data.alerteFuite,
                        alerteFuiteTypeContact: data.alerteFuiteTypeContact,
                        email: data.mail,
                        tel: data.tel,
                    });
                })
                .catch(error => {
                    console.error(preferenciesFetchError);
                    showAxiosMessageError(error, showMessage);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, []);

    const updateGestionFuiteAlerte = (gestionAlerteFuiteData: ContractGestionAlerteFuiteDto) => {
        setGestionAlerteFuite(gestionAlerteFuiteData);
        updateContratPreferences(gestionAlerteFuiteData.id, gestionAlerteFuiteData);
    };

    return (
        <>
            <ContractGestionAlerteFuiteUi
                loading={loading}
                gestionAlerteFuite={gestionAlerteFuite}
                updateGestionAlerteFuite={updateGestionFuiteAlerte}
            />
        </>
    );
}
